import Vue from 'vue';
import axios from 'axios';
import VueAxios from 'vue-axios';

Vue.use(VueAxios, axios);

const blogApi = axios.create({
  baseURL: (process.env.NODE_ENV === 'production') ? process.env.VUE_APP_BLOG_API : '/blog/',
});

Vue.prototype.$blogApi = blogApi;

const mainApi = axios.create({
  baseURL: (process.env.NODE_ENV === 'production') ? process.env.VUE_APP_API_URL : '/api/',
  headers: {
    Authorization: 'Bearer $2y$10$d6GYnC0BEdn6Vx40mtaLJOb1cwh8NDP.i.33/HpBCFll0yJ2fyHBO',
    // Authorization: `Bearer ${process.env.VUE_APP_API_KEY}`,
  },
});

Vue.prototype.$mainApi = mainApi;
